(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbSubformForm', fbSubformFormDirective);

    function fbSubformFormDirective() {
        return {
            restrict: "EA",
            scope: {
                fbElement: '=',
                model: '=',
                renderedElements: '='
            },
            templateUrl: 'common/libraries/formBuilder/subform/form',
            controller: fbSubformFormDirectiveCtrlfunction,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbSubformFormDirectiveCtrlfunction(FormBuilderHelper, $scope, lodash, FormBuilderService, RmsEnum, $timeout) {
        var vm = this;
        var fbService;
        var elementIdentifier;

        vm.addToModel = addToModel;
        vm.deleteFromModel = deleteFromModel;
        vm.hasMaxItems = hasMaxItems;
        vm.hasMinItems = hasMinItems;

        vm.showRowClass = showRowClass;
        vm.showRow = showRow;
        vm.toggleVisibility = toggleVisibility;
        vm.moveUp = moveUp;
        vm.moveDown = moveDown;
        vm.hasError = hasError;
        vm.canDelete = canDelete;
        vm.canAdd = canAdd;
        vm.generateChildIdentifier = generateChildIdentifier;
        vm.setDefault = setDefault;
        vm.hasDefaultOption = hasDefaultOption;

        this.$onInit = function() {
            vm.formIdentifier = $scope.$parent.vm.formIdentifier;
            fbService = FormBuilderService.get(vm.formIdentifier);
            elementIdentifier = $scope.$parent.vm.elementIdentifier;
            vm.currentElementIdentifier = elementIdentifier;
            vm.renderedElementsOptions = [];
            vm.getElementSize = FormBuilderHelper.getElementSize;
            vm.determineDisabled = FormBuilderHelper.determineDisabled;
            vm.view_only = lodash.get(fbService, 'fbData.settings.view_only', false);
            vm.default_field = lodash.get(vm.fbElement, 'options.default_field', 'default');

            init();
        }

        // $scope.$watch(function() { return vm.model.length; }, function() {
        //     console.log('scope.watch');
        //     if (vm.renderedElements.length < vm.model.length) {
        //         angular.forEach(vm.model, function(value, index) {
        //             console.log(value);
        //             if (!lodash.has(vm, 'renderedElements[' + index+ ']')) {
        //                 lodash.set(vm,'renderedElements[' + index + ']', {});
        //             }
        //         });
        //     }
        // });

        function toggleVisibility(row) {
            const renderedElementsOptions = lodash.find(vm.renderedElementsOptions, { tempRowId: row.tempRowId});
            if (renderedElementsOptions !== null) {
                renderedElementsOptions.showForm = !renderedElementsOptions.showForm;
            }
        }

        function moveUp(index) {
            shift(index, index - 1);
        }

        function moveDown(index) {
            shift(index, index + 1);
        }

        function filterElements(element) {
            return ['wysiwyg'].indexOf(element.type) >= 0;
        }

        function shift(currentPosition, newPosition) {
            // unloadWysiwyg(oldIndex, newIndex);
            const currentRowModel = lodash.get(vm.model, currentPosition);

            vm.model.splice(currentPosition, 1);
            vm.model.splice(newPosition, 0, currentRowModel);
            angular.forEach(vm.model, (row, index) => {
                row.order = index;
            });

            angular.forEach(vm.renderedElements, function(elements, index) {
                angular.forEach(elements, function(element, idx) {
                     if (filterElements(element)) {
                        element.refreshElement();
                    }
                });
            });
        }

        function init() {
            if (typeof vm.model == typeof undefined || vm.model == null) {
                vm.model = [];
            }
            if (lodash.has(vm.fbElement, 'subfields.options.min_items')
                && !!vm.fbElement.subfields.options.min_items) {
                while (vm.model.length < vm.fbElement.subfields.options.min_items) {
                    vm.model.push({});
                }
            }

            let defaultValue = null;
            if (lodash.has(vm.fbElement, 'options.default_value')) {
                defaultValue = lodash.get(vm.fbElement, 'options.default_value', null);
            }

            if (vm.model.length > 0) {
                for (var i = 0; i < vm.model.length; i++) {
                    const tempRowId = new Date().getTime() + i;
                    vm.renderedElements.push({
                        tempRowId: tempRowId
                    });
                    vm.renderedElementsOptions.push({ showForm: true, tempRowId: tempRowId });
                    vm.model[i].tempRowId = tempRowId;
                    vm.model[i].hid_position = (i+1);
                    if (defaultValue) {
                        const keys  = Object.keys(vm.fbElement.options.default_value);
                        const value = Object.values(vm.fbElement.options.default_value);
                        for (let idxDefaultValue = 0; idxDefaultValue < keys.length; idxDefaultValue++) {
                            lodash.set(vm.model[i], keys[idxDefaultValue], value[idxDefaultValue]);
                        }
                    }
                }
            }

            setFirstAsDefault();

            if (lodash.has(vm.fbElement, 'subfields.options.summary_header.enum_fields')) {
                lodash.forIn(vm.fbElement.subfields.options.summary_header.enum_fields, function(enumName) {
                    if (!RmsEnum.has(enumName)) {
                        RmsEnum.load(enumName);
                    }
                });
            }
        }

        function showRowClass(row) {
            const renderedElementsOptions = lodash.find(vm.renderedElementsOptions, { tempRowId: row.tempRowId});
            return (lodash.get(renderedElementsOptions ,'showForm', false)) ? "fa-angle-down" : "fa-angle-right";
        }

        function showRow(row) {
            const renderedElementsOptions = lodash.find(vm.renderedElementsOptions, { tempRowId: row.tempRowId});
            return renderedElementsOptions.showForm;
        }

        function addToModel() {
            const tempRowId = new Date().getTime();
            vm.model.push({
                hid_position: getNextHidPosition(),
                tempRowId: tempRowId,
            });
            vm.renderedElements.push({tempRowId: tempRowId});
            vm.renderedElementsOptions.push({ showForm: true, tempRowId: tempRowId });
        }

        function getNextHidPosition() {
            const obj = vm.model.reduce(function(result, o) {
                if (result === null) {
                    return o;
                }
                if (result.hid_position < o.hid_position) {
                    return o;
                }
                return result;
            }, null);
            if (obj === null) {
                return 1;
            }
            return obj.hid_position + 1;
        }

        function deleteFromModel(item) {
            var index = vm.model.indexOf(item);
            vm.model.splice(index, 1);
            vm.renderedElements.splice(index, 1);
        }

        function hasMaxItems() {
            if (!lodash.has(vm.fbElement, 'subfields.options.max_items')) { return true; }
            return (vm.fbElement.subfields.options.max_items > vm.model.length);
        }

        function hasMinItems() {
            if (!lodash.has(vm.fbElement, 'subfields.options.min_items')) {
                return true;
            }
            return (vm.fbElement.subfields.options.min_items < vm.model.length);
        }


        function hasError(index) {
            return fbService.elementsService.getValidationRule(elementIdentifier + '.' + index);
        }


        function canDelete() {
            if (vm.view_only) return false;
            if (vm.hasMinItems()) {
                return lodash.get(vm.fbElement, 'options.can_delete', true);
            }
            return false;
        }

        function canAdd() {
            return vm.view_only ? false : lodash.get(vm.fbElement, 'options.can_add', true);
        }

        function determineDisabled(element, rowModel) {
            if (!lodash.has(vm.fbElement, 'options.disable_fields') || !Array.isArray(vm.fbElement.options.disable_fields)) {
                return null;
            }

            var disabled_field = lodash.find(vm.fbElement.options.disable_fields, { 'target_field_name': element.name });
            if (!disabled_field) {
                return null;
            }

            var compared_value = lodash.get(rowModel, disabled_field.source_field_name, null);
            if (compared_value === null) {
                return null;
            }

            return !(lodash.get(disabled_field, 'value_flip', false)) ? compared_value : !compared_value;
        }

        function generateChildIdentifier(index, element_name) {
            return vm.currentElementIdentifier + '[' + index + '].' + element_name;
        }

        function setDefault($event, row) {
            // $event.preventDefault();
            defaultFunc(row);
        }

        function defaultFunc(row) {
            const result = vm.model.map((_row) => {
                var obj = {};
                lodash.set(obj, vm.default_field, (_row.$$hashKey == row.$$hashKey));
                return obj;
            });
            angular.merge(vm.model, result);
        }

        function setFirstAsDefault() {
            if (lodash.get(vm.fbElement.subfields.options, 'select_first_as_default', true) === true) {

                if (vm.model.length > 0) {
                    // check first if got default===true also
                    const defaultRow = lodash.find(vm.model, function(item) {
                        return lodash.get(item, vm.default_field, false);
                    });
                    if (!defaultRow) {
                        lodash.set(vm.model[0], vm.default_field, true);
                    }
                }
            }
        }
        function hasDefaultOption() {
            return !!lodash.get(vm.fbElement, 'subfields.options.select_default', false);
        }
    }
})();